import type { EChartsExtensionInstallRegisters } from 'echarts';
import ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';

function parseDataZoomPosition(ecIns: ExtensionAPI) {
  // 获取拖动条类型的datazoom模型
  const dataZoomModel = ecIns.getModel().queryComponents({
    mainType: 'dataZoom',
    subType: 'slider'
  });
  if (dataZoomModel.length === 0) {
    return;
  }

  dataZoomModel.forEach(model => {
    const dataZoomView = ecIns.getViewOfComponentModel(model);
    // 背景圆角 能改上半两个圆角
    dataZoomView?._displayables?.sliderGroup?.childAt(0)?.attr({
      shape: {
        r: 4
      }
    });
    // 修改数据背景圆角,用于下半两个圆角
    dataZoomView?._displayables?.dataShadowSegs?.forEach(group => {
      group.getClipPath().attr({
        shape: {
          r: 4
        }
      });
    });
    // 不再用echarts内部的位置算法（因为他的计算包含了偏移和缩放），直接使用原始配置的数据
    dataZoomView?.group?.attr({
      x: dataZoomView._location.x
    });
  });
}
export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (...args) => {
    const chart = args[1];
    parseDataZoomPosition(chart);
  });
}
